function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var sdkUtil = {
  /**
   *  전달한 parameter 가 모두 함수일 경우 true 를 반환합니다.
   *
   * @param  {...any} args
   * @returns {boolean}
   */
  areAllFunctions: function areAllFunctions() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return !args.some(function (a) {
      return typeof a !== 'function';
    });
  },
  areAllStrings: function areAllStrings() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return !args.some(function (a) {
      return typeof a !== 'string';
    });
  },
  /**
   *  모든 parameter가 Truthy 또는 숫자 일 경우 true 를 반환합니다.
   * @param  {...any} args
   * @returns {boolean}
   */
  haveAllValue: function haveAllValue() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return args.every(function (a) {
      return typeof a === 'number' ? true : !!a;
    });
  },
  areAllTypes: function areAllTypes(type) {
    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }
    // eslint-disable-next-line valid-typeof
    return !args.some(function (a) {
      return _typeof(a) !== type;
    });
  },
  snake2Pascal: function snake2Pascal() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return str.split('_').map(function (s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }).join('');
  },
  snake2Camel: function snake2Camel() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return str.split('_').map(function (s, i) {
      return i === 0 ? s : s.charAt(0).toUpperCase() + s.slice(1);
    }).join('');
  },
  convertObjectPropertyNameSnake2Camel: function convertObjectPropertyNameSnake2Camel(obj) {
    var _this = this;
    return Object.entries(obj).reduce(function (prev, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      // eslint-disable-next-line no-param-reassign
      prev[_this.snake2Camel(key)] = value;
      return prev;
    }, {});
  },
  /**
   * 전달받은 데이터를 base64로 인코딩합니다.
   * - 데이터가 `string`이면 그대로 인코딩
   * - 데이터가 `object`라면 `JSON.stringify` 후 인코딩
   */
  encodeToBase64: function encodeToBase64(data) {
    var str = typeof data === 'string' ? data : JSON.stringify(data);
    var bytes = new TextEncoder().encode(str);
    var binaryStr = String.fromCodePoint.apply(String, _toConsumableArray(bytes));
    return btoa(binaryStr);
  },
  decodeFromBase64: function decodeFromBase64(base64) {
    var binaryStr = atob(base64);
    var bytes = Uint8Array.from(binaryStr, function (c) {
      return c.codePointAt(0);
    });
    return new TextDecoder().decode(bytes);
  }
};
export default sdkUtil;